import styled from 'styled-components';

import {colors, font} from '../../../../../theme';

export const FlexWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
`;

export const Label = styled.span`
    display: inline-flex;
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0px;
    color: ${colors.textSecondary};
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 1fr) 38px;
    row-gap: 10px;
`;

export const Headline = styled.div<{required?: boolean}>`
    display: flex;
    align-items: center;
    gap: 4px;
    position: relative;
    box-sizing: border-box;
    padding: 8px 16px;
    background-color: ${colors.background};
    &:last-child {
        border-radius: 4px 4px 0 0;
    }
    &:first-child {
        border-radius: 4px 0 0 4px;
    }
    &:not(:nth-child(7)) {
        &:before {
            position: absolute;
            right: 0;
            width: 1px;
            height: 18px;
            background: ${colors.textMuted};
            content: '';
        }
    }

    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
    color: grey;

    ${(p) =>
        p.required &&
        `
        &:after {
            content: '*';
            color: red;
            width: 10px;
            height: 10px;
            display: flex;
            transform: translateY(-6px);
        }    
    `}
`;

export const HeadControlElement = styled.div`
    display: flex;
    box-sizing: border-box;
    padding: 8px 16px;
`;

export const BodyElement = styled.div<{dataMutualIndex?: number}>`
    position: relative;
    display: flex;
    box-sizing: border-box;
    padding: 8px 16px;

    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;

    &.whoop:not(:nth-child(7n -4)) {
        &:after {
            position: absolute;
            right: 0;
            width: 1px;
            height: 18px;
            background: ${colors.textMuted};
            content: '';
        }
    }

    &.whoop123:not(:nth-child(7n -3)) {
        &:after {
            position: absolute;
            right: 0;
            width: 1px;
            height: 18px;
            background: ${colors.textMuted};
            content: '';
        }
    }
`;

export const GroupName = styled.span`
    display: inline-flex;
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: ${colors.brandPrimary};
`;
